import Tag from './Tag.jsx';

export default Tag;
